import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Button from "../../components/button";
import { useAuth } from "../../context/authContext";
import { requestEmailCode } from "../../api/auth";
import { getAuthApiError } from "../../utils/auth-api-error";
import LoginShell from "./LoginShell";
import styles from "./style.module.css";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function LoginEmailPage() {
  const navigate = useNavigate();
  const { status } = useAuth();
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  // Куда бы пользователя ни занесла ссылка до логина (ProtectedRoute передаёт её как
  // state.from) — после входа всегда ведём на главный экран, а не туда, откуда пришёл.
  useEffect(() => {
    if (status === "authed") {
      navigate("/", { replace: true });
    }
  }, [status, navigate]);

  const submit = useCallback(async () => {
    setError(null);
    const trimmed = email.trim().toLowerCase();
    if (!EMAIL_RE.test(trimmed)) {
      setError("Некорректный адрес");
      return;
    }
    setSubmitting(true);
    try {
      await requestEmailCode(trimmed);
      navigate("/login/code", { state: { email: trimmed } });
    } catch (e) {
      setError(getAuthApiError(e, "Не удалось отправить код. Попробуйте позже."));
    } finally {
      setSubmitting(false);
    }
  }, [email, navigate]);

  if (status === "loading") return null;

  return (
    <LoginShell>
      <h1 className={styles.title}>Войти в аккаунт</h1>
      <p className={styles.subtitle}>
        Введите email, чтобы войти или зарегистрироваться
      </p>

      <form
        className={styles.form}
        onSubmit={(e) => {
          e.preventDefault();
          void submit();
        }}
      >
        <input
          className={styles.input}
          type="email"
          inputMode="email"
          autoComplete="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={submitting}
          autoFocus
        />
        {error && <p className={styles.error}>{error}</p>}
        <Button
          className={styles.primaryAction}
          label="Далее"
          onClick={() => void submit()}
          disabled={submitting || !email.trim()}
          loading={submitting}
        />
      </form>
    </LoginShell>
  );
}

export default LoginEmailPage;
